module.exports = __webpack_public_path__ + "static/media/Docs.8d893443.svg";